import type { UserWithOrganizationMembershipAndSubscriptionData } from "@arbeidsark/shared"
import React from "react"

export const UserContext =
  React.createContext<UserWithOrganizationMembershipAndSubscriptionData | null>(
    null,
  )
